// extracted by mini-css-extract-plugin
export default {"facts__highlight":"V1JGuoY","facts__subline":"OOhwg7O"};